export const SET_TOASTIFY_STATUS = "toastify/SET_TOASTIFY_STATUS";
